<template>
  <div class="goodList">
    <div class="cartIcon">
      <a href="/vm/cart">
        <div class="cartIcon-main">
          <img class="good_cart" src="./images/cart-icon.png">
          <span class="white f10_rem">购物车</span>
        </div>
      </a>
    </div>
    <van-list
      :loading="allGoodLoaing"
      :finished="allGoodFinished"
      :offset="0"
      finished-text="没有更多了"
      @load="onLoad">
      <ul>
        <li v-for="goods in goodsList" :key="goods.goodsId">
          <a :href="`/vm/goodDetails/${goods.goodsId}?fromShopId=${goods.shopIds}`">
            <div class="good_image">
                <van-image lazy-load v-if="goods.goodsImg" :src="`${goods.goodsImg}?imageView2/1/w/180/h/180`" alt=""></van-image>
                <van-image lazy-load v-else src="https://filesouthcdn.nxin.com/nxsc_150277595667202204185653403551.png?imageMogr2/auto-orient/thumbnail/1200000@" alt=""></van-image>
            </div>
          </a>
          <div class="good_main">
            <a :href="`/vm/goodDetails/${goods.goodsId}?fromShopId=${goods.shopIds}`">
              <p class="good_name ellipsis_two">{{goods.goodsName}}</p>
              <p class="good_label">
                <span class="good_label_item" v-if="goods.promotionType === '折扣'">限时折扣</span>
                <span class="good_label_item" v-if="goods.promotionType === '买赠'">买{{goods.promotionStock}}赠1</span>
              </p>
            </a>
            <p class="good_price_wrap" v-if="goods.sellFactPrice">
              <span class="f11_rem good_price">¥ <em class="f40_rem">{{goods.sellFactPriceStr}}</em></span>
              <img class="good_cart" src="./images/good-cart.png" alt="" @click="addCart(goods)">
            </p>
            <p class="good_price_wrap" v-else>
              <span class="f16 good_price">点击询价</span>
            </p>
          </div>
        </li>
      </ul>
    </van-list>
  </div>
</template>
<script>
import { Toast } from "vant";
import { mapState } from "vuex";
import common from "../../../assets/js/common";

export default {

  data() {
    return {
      pageNum: 1,
      goodsList: [],
      allGoodLoaing: false,
      allGoodFinished: false,
      allLoading: false
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo,
    userIdentity: state => state.app.userIdentity
  }),
  created() {
    console.log("userIdentity", this.userIdentity);
    this.getGoodsList();
  },
  methods: {
    // 上拉加载
    onLoad() {
      if (this.goodsList.length) {
        this.allGoodLoaing = true;
        this.pageNum += 1;
        this.getGoodsList();
      }
    },

    // 获取商品列表
    getGoodsList() {
      const { pageNum, goodsList } = this;
      const { ID, Type } = this.userIdentity;
      // Type 1 — 个人 0 — 企业
      const busType = Type === 1 ? "1" : "2";
      this.$store.dispatch("goods/goods/getDsjapiList", {
        page: pageNum,
        page_size: 10,
        order_by: 1,
        in_business_id: ID,
        in_business_type: busType,
        out_business_type: 12,
        tracking_code: "app_znt_haodian_youpin",
        use_always_buy: 1,
        use_accurate: 1
      }).then((data) => {
        this.allGoodLoaing = false;
        this.goodsList = goodsList.concat(data || []);
        if (!data.length) {
          this.allGoodFinished = true;
        }
      });
    },

    // 加入购物车
    addCart(goods) {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      const params = {
        goodsId: goods.goodsId,
        goodsQuantity: 1,
        fromShopId: goods.shopIds
      };
      this.$store.dispatch("goodDetails/goodDetails/addCart", { params }).then((data) => {
        if (data.success === true) {
          Toast("添加成功");
          this.$emit("getCountCart");
        } else if (data.errorcode === -2) {
          window.location.href = `${process.env.VUE_APP_APP}mob/goods/isShowDisplayPrice.do?goodsId=${goods.goodsId}&url=/mob/shop/shopDetail/${goods.shopIds}`;
        } else {
          Toast(data.errormsg);
        }
      });
    }
  }
};
</script>


<style lang="scss" scoped>
  @import './style.scss';
</style>
